(function () {
    'use strict';
    angular
        .module('app.widgets')
        .factory('calendarService', calendarService);

    /* @ngInject */
    function calendarService() {
        return{
            moveDateTimeZone:moveDateTimeZone
        };

        function moveDateTimeZone(timezone, date) {
            if (timezone) {
                date.zone(timezone, true);
            }
            return date;
        }
    }
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-Calendar.service.js
 ** module id = 181
 ** module chunks = 0
 **/